<template>
  <section>
    <NavBar />
    <HomeHero />
    <BoxNew />
    <TopMessage />
    <Features :data="features" />
    <Extractors :data="tags" />
    <Visualizers :data="visualizers" />
    <Partners :data="partners" />
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column is-6">
            <h2 class="title is-2">
              Ponte en contacto con nosotros
            </h2>
            <div class="my-5 my-md-6 my-lg-7"></div>
            <p class="subtitle">
              ¿Tienes curiosidad por nuestro producto, quieres hablar con Ventas
              o simplemente quieres saber más sobre nuestro producto? ¡Ingresa
              tu información en el formulario, describa su consulta y nos
              pondremos en contacto contigo lo antes posible!
            </p>
            <img
              class="is-hidden-mobile"
              :src="imgNewsletter"
              :class="$style.imgContact"
              alt="cantacto"
              title="contacto datalized connect"
            />
          </div>
          <div class="column is-5">
            <ContactForm isHorizontal />
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import {
  NavBar,
  HomeHero,
  BoxNew,
  TopMessage,
  Partners,
  Features,
  Extractors,
  Visualizers,
  Footer,
  ContactForm,
} from "@/components";
import { imgNewsletter } from "@/assets/images";
import { partners, features, visualizers } from "@/utils";

export default {
  name: "Home",
  components: {
    NavBar,
    HomeHero,
    BoxNew,
    TopMessage,
    Partners,
    Features,
    Extractors,
    Visualizers,
    Footer,
    ContactForm,
  },
  data: function () {
    return {
      partners: partners,
      features: features,
      visualizers: visualizers,
      imgNewsletter: imgNewsletter,
    };
  },
  computed: {
    ...mapGetters("root", {
      tags: "getFilteredExtractors",
    }),
  },
};
</script>

<style lang="scss" module>
.imgContact {
  max-width: 30%;
}
</style>
